import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { DialogHelper } from "../core/util/dialogHelper";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export class EditArticle extends React.Component<EditArticleAppProps, any> {
    common = new AppHelper();
    translations: StringKeyDictionary<string>;
    customPricesVisible: boolean = null;
    cache = {
        ArtKey: {
            ArtNr: null,
            SerienNr: null,
            ChargenNr: null
        }
    };
    constructor(props: EditArticleAppProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);

        this.cache.ArtKey = {
            ArtNr: this.props.entity.Artikelnr,
            ChargenNr: this.props.entity.Chargennr,
            SerienNr: this.props.entity.Seriennr,
        };
    }


    private _updateFromPriceList = async (anzahl: number = null, datum: Date = null, force: boolean = false) => {
        anzahl = anzahl ?? this.props.entity.Anzahl;
        datum = datum ?? this.props.entity.Datum;
        console.log("Artikel: " + this.props.entity.Artikelnr + " Anzahl: " + anzahl, this.props.entity);
        if (this.customPricesVisible) {
            let result: JsonResultClass<MaterialPriceDiscount> = null;
            if (this.props.context.contextType == "ticketArticleEdit")
                result = await HTTPService.get<JsonResultClass<MaterialPriceDiscount>>("ProcedureArticle/GetPrice",
                    {
                        artikelNr: this.props.entity.Artikelnr,
                        anzahl: anzahl,
                        problemNr: this.props.context.keyVal1,
                        datum: datum
                    });
            if (this.props.context.contextType == "projectArticleEdit")
                result = await HTTPService.get<JsonResultClass<MaterialPriceDiscount>>("ProjectArticle/GetPrice",
                    {
                        artikelNr: this.props.entity.Artikelnr,
                        anzahl: anzahl,
                        projNr: this.props.context.keyVal1,
                        datum: datum
                    });
            if (this.props.context.contextType == "resourcePlanningArticleEdit")
                result = await HTTPService.get<JsonResultClass<MaterialPriceDiscount>>("ResourcePlanningArticle/GetPrice",
                    {
                        artikelNr: this.props.entity.Artikelnr,
                        anzahl: anzahl,
                        projNr: this.props.context.keyVal1,
                        datum: datum
                    });
            if (result && result.Code == 0) {
                this.props.entity.MaterialPriceDiscount.Price = result.Data.Price;
                this.props.entity.MaterialPriceDiscount.PurchasePrice = result.Data.PurchasePrice;
                this.props.entity.MaterialPriceDiscount.Discount = result.Data.Discount;
                if (force || !this.props.entity.CustomPrices) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Epreis", this.props.entity.MaterialPriceDiscount.Price);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.EkPreis", this.props.entity.MaterialPriceDiscount.PurchasePrice);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Rabatt", this.props.entity.MaterialPriceDiscount.Discount);
                    this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis,
                        this.props.entity.Epreis, this.props.entity.Rabatt);
                    this.setState({});
                }
            }
        }
    }
    private _updateValues(quantity: number, purchasePrice: number, unitPrice: number, discount: number) {
        let sum = parseFloat((quantity * unitPrice).toFixed(2));
        let discountValue = parseFloat(((sum / 100) * discount).toFixed(2));
        sum -= discountValue;
        MetaDataHelper.setFieldValue(this.props.entity, "entity.Gpreis", sum);

        sum = parseFloat((quantity * purchasePrice).toFixed(2));
        MetaDataHelper.setFieldValue(this.props.entity, "entity.Kosten", sum);
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextEpreis = () => {
        return this.customPricesVisible && this.props.entity.CustomPrices ?
            Helper.getTranslation("Field.Material.FromPL") + " " + this.props.entity.MaterialPriceDiscount.Price.toFixed(2) : null;
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextColorEpreis = () => {
        return this.customPricesVisible && this.props.entity.CustomPrices ?
            this.props.entity.MaterialPriceDiscount.Price === this.props.entity.Epreis ? "#448aff" : "#d50000" : null
    }


    // noinspection JSUnusedGlobalSymbols
    getInfoTextEkpreis = () => {
        return this.customPricesVisible && this.props.entity.CustomPrices ?
            Helper.getTranslation("Field.Material.FromPL") + " " + this.props.entity.MaterialPriceDiscount.PurchasePrice.toFixed(2) : null;
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextColorEkpreis = () => {
        return this.customPricesVisible && this.props.entity.CustomPrices ?
            this.props.entity.MaterialPriceDiscount.PurchasePrice === this.props.entity.EkPreis ? "#448aff" : "#d50000" : null
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextRabatt = () => {
        return this.customPricesVisible && this.props.entity.CustomPrices ?
            Helper.getTranslation("Field.Material.FromPL") + " " + this.props.entity.MaterialPriceDiscount.Discount + " %" : null
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextColorRabatt = () => {
        if (!this.props.entity.CustomPrices)
            return null;
        return this.props.entity.MaterialPriceDiscount.Discount === this.props.entity.Rabatt ? "#448aff" : "#d50000";
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextGpreis = () => {
        if (this.props.entity.Rabatt != 0) {
            return (this.props.entity.Anzahl * this.props.entity.Epreis).toFixed(2) + " - " + this.props.entity.Rabatt.toString() + " %";
        }
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextColorGpreis = () => {
        return "#448aff";
    }
    // noinspection JSUnusedGlobalSymbols
    executeKosten = () => {
        const text = Helper.getTranslation("Field.Material.EnterTotalCost");
        const kosten = this.props.entity.Kosten;
        DialogHelper.promptNumber(text, kosten, "0.00", 2, true, 0, 500).then((result) => {
            if (!Helper.isNullOrEmpty(result)) {
                const sum = parseFloat(result);
                if (kosten != sum) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.CustomPrices", true);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.EkPreis", sum / this.props.entity.Anzahl);
                    this.updateReadOnly(false);
                    this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis, this.props.entity.Epreis, this.props.entity.Rabatt);
                    this.setState({});
                }
            }
        })
    }

    // noinspection JSUnusedGlobalSymbols
    executeGpreis = () => {
        const text = Helper.getTranslation("Field.Material.EnterTotalPrice");
        const gpreis = this.props.entity.Gpreis;
        DialogHelper.promptNumber(text, gpreis, "0.00", 2, true, 0, 500).then((result) => {
            if (!Helper.isNullOrEmpty(result)) {
                const sum = parseFloat(result);
                if (sum != gpreis) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.CustomPrices", true);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Rabatt", 0);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Epreis", sum / this.props.entity.Anzahl);
                    this.updateReadOnly(false);
                    this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis, this.props.entity.Epreis, this.props.entity.Rabatt);
                    this.setState({});
                }
            }
        })
    }
    componentDidMount() {
        if (this.customPricesVisible == null) {
            const field = MetaDataHelper.getFieldByModelName(this.props.metadata, "entity.CustomPrices");
            let visible = false;
            if (field != null) {
                if (typeof (field.visibleCondition) == "string") visible = this.common.evalAction(field.visibleCondition);
                else visible = field.visibleCondition as boolean;
            }
            this.customPricesVisible = visible;
        }

        let readOnly = this.customPricesVisible && !this.props.entity.CustomPrices;

        this.updateReadOnly(readOnly);
    }

    private updateReadOnly(value: boolean) {
        if (this.customPricesVisible) {
            MetaDataHelper.setReadOnly(this.props.metadata, "entity.Epreis", value);
            MetaDataHelper.setReadOnly(this.props.metadata, "entity.EkPreis", value);
            MetaDataHelper.setReadOnly(this.props.metadata, "entity.Rabatt", value);
        }
    }

    handleFieldChange = async (field: { model: string }, value: any, dataItem = null, isInit = false) => {
        console.log("handleFieldChange", field, value, dataItem);
        switch (field.model) {
            case "entity.Anzahl":
                await this._updateFromPriceList(value as number);
                this._updateValues(value, this.props.entity.EkPreis, this.props.entity.Epreis, this.props.entity.Rabatt);
                break;
            case "entity.EkPreis":
                this._updateValues(this.props.entity.Anzahl, value, this.props.entity.Epreis, this.props.entity.Rabatt);
                break;
            case "entity.Epreis":
                this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis, value, this.props.entity.Rabatt);
                break;
            case "entity.Rabatt":
                this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis, this.props.entity.Epreis, value);
                break;
            case "entity.Datum":
                await this._updateFromPriceList(null, value as Date);
                this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis, this.props.entity.Epreis, this.props.entity.Rabatt);
                break;
            case "entity.Maschnr":
                await this.loadIndividualFieldsMaind(value);
                break;
            case "entity.CustomPrices":
                this.updateReadOnly(!value);
                if (!value) {
                    await this._updateFromPriceList(null, null, true);
                }
                break;
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    handleIsSearchFieldFullObjectModel = async (field: { model: string }, dataItem: any) => {
        console.log("handleIsSearchFieldFullObjectModel", field, dataItem);
        let changed = true;
        switch (field.model) {
            case "entity.Artikelnr":
            case "entity.Artikelnummer":
                if (Helper.hasValue(dataItem)) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Artikelnr", dataItem.artnr);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Seriennr", dataItem.seriennr);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Chargennr", dataItem.chargennr);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Artikelnummer", dataItem.artikelnummer);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Produkt", dataItem.produkt);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Bezeichnung", dataItem.bezeichnung);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Epreis", dataItem.preis);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.EkPreis", dataItem.ekpreis);

                    //reassign the object to trigger the expander/panel bar
                    //if only the properties are changed, the panel bar does not notice there was a change...
                    this.cache.ArtKey = {
                        ArtNr: dataItem.artnr,
                        ChargenNr: dataItem.chargennr,
                        SerienNr: dataItem.seriennr,
                    };

                    MetaDataHelper.setFieldValue(this.props.entity, "entity.CustomPrices", false);
                    this.updateReadOnly(true);
                    // KT - _updateFromPriceList aktualisiert die Summen auch, aber nur bei erfolgreicher Ermittlung
                    //   für die Templates wird aber keine Ermittlung gemacht. Die Summen sollte man aber trotzdem aktualisieren.
                    this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis, this.props.entity.Epreis, this.props.entity.Rabatt);
                    await this._updateFromPriceList(null, null, true);
                    this.setState({});
                }
                break;
            default:
                changed = false;
                break;
        }

        if (changed) {
            this.common.handleFieldChange({ model: "" }, null, null);
        }
    }

    private loadIndividualFieldsMaind = async (maschNr: string) => {
        let result = await HTTPService.get<JsonResultClass>("Machine/GetMaind?maschNr=" + encodeURIComponent(maschNr));
        if (result.Code == 0) {
            MetaDataHelper.setFieldValue(this.props.entity, "entity.IndividualFieldsMaind", result.Data);
            this.setState({});
        }
    }

    save = async (closeAfterSave: boolean) => {
        closeAfterSave = true;
        if (this.common.validate()) {
            const result = await HTTPService.post(this.props.saveUrl, this.props.entity);
            if (result.Code === 0) {
                let indivData = result.Data.IndividualFields;
                Helper.updateEntity(this.props.entity, result.Data);
                for (let key in indivData) {
                    this.props.entity.IndividualFields[key] = indivData[key];
                }
                this.props.entity.IsNew = false;
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, closeAfterSave);
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel });
        return <CommonApp {...props} />;
    }
}

export interface EditArticleAppProps extends AppBaseProps {
    entity: ArticleEntity;
    context: Context;
    saveUrl: string;
}

export interface ArticleEntity extends Entity {
    Anzahl: number;
    Epreis: number;
    Rabatt: number;
    Gpreis: number;
    Kosten: number;
    EkPreis: number;
    Datum: Date;
    Artikelnr: string;
    Chargennr: string;
    Seriennr: string;
    Adrnr: string;
    editAmount?: boolean;
    MaterialPriceDiscount?: MaterialPriceDiscount;
    CustomPrices: boolean;
}

export interface MaterialPriceDiscount {
    Discount: number;
    PurchasePrice: number;
    Price: number;
}